import type {
  PayoutRequestDetail,
  PayoutRequestsListResult,
} from "@/modules/wallet/domain/repo/payout-requests";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { PayoutRequestDetail, PayoutRequestsListResult };
export type PayoutRequestItem = PayoutRequestsListResult["data"][number];

export type CreatePayoutBody = {
  walletId: string;
  amount: number;
  currency: "LAK" | "THB" | "USD";
  payoutMethod: "bank_transfer" | "cash";
  payoutDestination?: Record<string, unknown>;
};

export type PayoutStats = {
  pendingTotal: number;
  processingCount: number;
  paidToday: number;
  failureRate: number;
};

export const payoutApi = {
  async getStats(): Promise<PayoutStats> {
    return fetcher.get<PayoutStats>(`${config.apiUrl}/payout/stats`);
  },

  async list(query: OffsetPageQueryDTO): Promise<PayoutRequestsListResult> {
    const url = new URL(`${config.apiUrl}/payout`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<PayoutRequestsListResult>(url.toString());
  },

  async getDetail(id: string): Promise<PayoutRequestDetail> {
    return fetcher.get<PayoutRequestDetail>(`${config.apiUrl}/payout/${id}`);
  },

  async create(body: CreatePayoutBody): Promise<{ id: string }> {
    return fetcher.post<{ id: string }>(`${config.apiUrl}/payout`, body);
  },

  async approve(id: string): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/payout/${id}/approve`,
    );
  },

  async process(id: string): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/payout/${id}/process`,
    );
  },
};
